import { render, staticRenderFns } from "./UploaderFiles.vue?vue&type=template&id=9b09c030&scoped=true&lang=true"
import script from "./UploaderFiles.vue?vue&type=script&lang=js"
export * from "./UploaderFiles.vue?vue&type=script&lang=js"
import style0 from "./UploaderFiles.vue?vue&type=style&index=0&id=9b09c030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b09c030",
  null
  
)

export default component.exports